import { Paper } from '@shared/components';

import {
  RecurringExamEventReviewInfoDetailsSection,
  type RecurringExamEventInfoDetailsSectionProps,
} from '../recurring-exam-event-info-details-section';
import {
  RecurringExamEventSummarySection,
  type RecurringExamEventSummarySectionProps,
} from '../recurring-exam-event-summary-section';

type RecurringExamEventReviewInfoProps = RecurringExamEventInfoDetailsSectionProps &
  RecurringExamEventSummarySectionProps;

export default function RecurringExamEventReviewInfo(
  props: Readonly<RecurringExamEventReviewInfoProps>,
) {
  const {
    registrationRange,
    dateRange,
    location,
    buildings,
    province,
    proctor,
    examStartTime,
    examEndTime,
    summary,
  } = props;
  return (
    <Paper
      sx={{
        flexDirection: 'column',
        padding: (theme) => theme.spacing(6),
        gap: (theme) => theme.spacing(6),
      }}
    >
      <RecurringExamEventSummarySection summary={summary} />
      <RecurringExamEventReviewInfoDetailsSection
        registrationRange={registrationRange}
        dateRange={dateRange}
        location={location}
        buildings={buildings}
        province={province}
        proctor={proctor}
        examStartTime={examStartTime}
        examEndTime={examEndTime}
      />
    </Paper>
  );
}
